// Shared site script: navbar scroll, auth hydration, analytics. Every page.
import { initAnalytics, trackPageView } from './lib/analytics.js';
import { authReady, getUser, onAuth, resolveIsAdmin } from './lib/auth.js';

// Dark-hero navbar: transparent at the top of dark-hero pages, solid once scrolled.
function initNavbarScroll() {
  const nav = document.getElementById('main-nav');
  if (!nav) return;
  if (!document.body.classList.contains('has-dark-hero')) return;
  const onScroll = () => nav.classList.toggle('site-nav--dark', window.scrollY <= 30);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// Auth-dependent chrome (was Navbar/Footer reading useAuth).
function applyAuthState() {
  const user = getUser();
  const authPath = user ? '/account' : '/login';
  const authLabel = user ? 'Account' : 'Log in';
  ['nav-auth', 'nav-auth-mobile'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) { el.href = authPath; el.textContent = authLabel; }
  });
  const footerAuth = document.getElementById('footer-auth');
  if (footerAuth) {
    footerAuth.href = authPath;
    footerAuth.textContent = user ? 'My account' : 'Log in';
  }
}

function hydrateAuthChrome() {
  // showAuthButtons: hidden on the gettingaway.co.uk production host.
  if (/gettingaway\.co\.uk$/.test(window.location.hostname)) {
    document.querySelectorAll('.js-auth-area').forEach((el) => { el.style.display = 'none'; });
  }
  authReady.then(async () => {
    applyAuthState();
    onAuth(applyAuthState);
    if (getUser() && await resolveIsAdmin()) {
      ['nav-admin', 'account-nav-admin'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.hidden = false;
      });
    }
  });
}

function init() {
  initNavbarScroll();
  hydrateAuthChrome();
  initAnalytics();
  trackPageView(window.location.pathname, document.title);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
